import React from 'react';
import './ModeratorAddPlayerPopup.css'
import ModeratorAddPlayerPopupCard from "./ModeratorAddPlayerPopupCard";
import {PLAYERS_IN_TEAMS_COUNT, TEAMS_COUNT} from "../../../constants/Constants";

class ModeratorAddPlayerPopup extends React.Component {
    constructor() {
        super();
        this.state = {
            selectedPlayers: [],
            isStateParentChanged: true
        }
    }

    onPlayerChecked(player, isChecked) {
        let players = this.state.selectedPlayers;
        if (!isChecked) {
            players = players.filter((item) => item !== player);
            this.props.selectedPlayers.filter((item) => item !== player);
            this.setState({
                selectedPlayers: players,
                isStateParentChanged: false
            });
        }
        if (players.length < PLAYERS_IN_TEAMS_COUNT) {
            if (isChecked) {
                players.push(player);
            }

            this.setState({
                selectedPlayers: players,
                isStateParentChanged: false
            });
        }
    }

    onSubmit() {
        this.props.onSubmit(this.state.selectedPlayers);
        this.setState({
            isStateParentChanged: true
        })
    }

    onCancel() {
        this.props.onCancel();
        this.setState({
            selectedPlayers: [],
            isStateParentChanged: true
        })
    }

    checkedInPanel(value) {
        return this.state.selectedPlayers.includes(value);
    }

    checkIsPlayerBusy(player) {
        return this.props.allOtherPlayers.includes(player);
    }

    render() {
        console.log(this.props.players)
        if (!this.props.players) return "";
        if (this.state.isStateParentChanged && this.props.selectedPlayers) {
            for (let i = 0; i < this.props.selectedPlayers.length; i++)
                this.state.selectedPlayers.push(this.props.selectedPlayers[i]);
        }
        const cardsCount = TEAMS_COUNT;
        const playersCount = PLAYERS_IN_TEAMS_COUNT;
        let playersCard = []

        for (let i = 0; i < cardsCount; i++) {
            playersCard.push(<div key={i} className={
                i === 0 || i === cardsCount - 1
                    ? 'moderator-add-player-popup-cards-container-outer' : 'moderator-add-player-popup-cards-container-inner'}>
                {this.props.players.slice(0, cardsCount * playersCount).map((value, index) => {
                    if (index < playersCount * i || index > playersCount * (i + 1) - 1)
                        return "";
                    else
                        return <ModeratorAddPlayerPopupCard
                            key={index}
                            player={value}
                            isSelected={this.checkedInPanel(value)}
                            isBusy={this.checkIsPlayerBusy(value)}
                            onSelectPlayer={this.onPlayerChecked.bind(this)}/>
                })}
            </div>);
            playersCard.push(<div key={'s-' + i} className='moderator-add-player-delimeter'/>);
        }
        return <div className='popup-darker'>
            <div className='moderator-add-player-popup-container'>
                <div className='moderator-add-player-popup-header'>
                    <div className="moderator-add-player-header-text">
                        {`Выбрано участников: ${this.state.selectedPlayers.length}/${PLAYERS_IN_TEAMS_COUNT}`}
                    </div>
                </div>
                <div className='moderator-add-player-cards-widget'>
                    {playersCard}
                </div>
                <div className='moderator-add-player-button-container'>
                    <button className='main-btn moderator-add-player-button'
                            onClick={this.onSubmit.bind(this)}>Подтвердить
                    </button>
                    <button className='sec-btn moderator-add-player-button' onClick={this.onCancel.bind(this)}>Отмена
                    </button>
                </div>
            </div>

        </div>
    }
}

export default ModeratorAddPlayerPopup;
